import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const CartContainerWrapper = styled(Box)(({ theme }) => ({
  '--header-h': '72px', // adjust if your TopNavbar is a different height
  position: 'relative',
  right: 0,
  top: 'var(--header-h)',
  width: '35vw',
  height: 'calc(100vh - var(--header-h))',
  backgroundColor: '#fff',
  boxShadow: '-2px 0 10px rgba(0,0,0,0.2)',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 1400, // above the overlay (1200)
  overflow: 'hidden',
  transition: 'top 0.2s ease, height 0.2s ease',

  '&.scrolled': {
    top: 0,
    height: '100vh',
  },

  [theme.breakpoints.down('lg')]: { width: '40vw' },
  [theme.breakpoints.down('md')]: { width: '50vw' },
  [theme.breakpoints.down('sm')]: { width: '100vw' },
}));

export const ClearCartWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '8px 16px',
  [theme.breakpoints.down('sm')]: { padding: '8px 12px' },
}));

export const CartItemsWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '20px',
  minHeight: 0,
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    padding: '15px',
    gap: '10px',
  },
}));

export const CartSummaryWrapper = styled(Box)(({ theme }) => ({
  padding: '20px',
  borderTop: '1px solid #ccc',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '300px',
  [theme.breakpoints.down('sm')]: { padding: '15px' },
}));

export const CartSummaryContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  flexWrap: 'nowrap',
  height: '100%',
  [theme.breakpoints.down('sm')]: { flexDirection: 'column', height: 'auto' },
}));

export const SummaryLeftSection = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: '250px',
  display: 'flex',
  flexDirection: 'column',
  paddingRight: '16px',
  borderRight: '1px solid #ccc',
  [theme.breakpoints.down('sm')]: { borderRight: 'none', paddingRight: 0, marginBottom: '12px' },
}));

export const SummaryRightSection = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: '250px',
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '16px',
  [theme.breakpoints.down('sm')]: { paddingLeft: 0 },
}));

export const SummaryRightInner = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  textAlign: 'right',
}));

export const SummaryRightTop = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const SummaryRightSpacer = styled(Box)(() => ({
  flexGrow: 1,
}));

export const SummaryRightBottom = styled(Box)(() => ({
  marginTop: 'auto',
}));

export const ToSectionWrapper = styled(Box)(({ theme }) => ({
  marginBottom: '16px',
  padding: '16px',
  borderBottom: '1px solid #ccc',
  [theme.breakpoints.down('sm')]: { padding: '12px' },
}));

export const ToSectionHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '8px',
});

export const ToSectionContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const ProductCard = styled(Box)(() => ({
  background: "#fff",
  borderRadius: 8,
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  padding: 16,
  paddingBottom: 140,
  display: "flex",
  flexDirection: "row",
  width: "100%",
  height: "auto",
  minHeight: 120,
  transition: "box-shadow 0.2s ease",
  textAlign: "left",
  border: "1px solid #e0e0e0",
  marginBottom: 12,
  "&:hover": {
    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
  },
}));

export const ProductCardActions = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  gap: '8px',
  minWidth: 80,
});

export const ProductCardContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
});

export const ProductImage = styled(Box)(() => ({
  width: 80,
  height: 80,
  backgroundColor: '#eee',
  borderRadius: 6,
  objectFit: 'cover',
  flexShrink: 0,
  marginRight: 12,
}));

export const CartActionsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '20px',
  borderTop: '1px solid #ccc',
  backgroundColor: '#fafafa',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '12px',
    padding: '15px',
  },
}));

export const SignInSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  paddingTop: '32px',
  paddingBottom: '32px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '24px',
    paddingBottom: '24px',
  },
}));

export const SignInText = styled(Typography)(({ theme }) => ({
  marginTop: '16px',
}));
